import React from "react";
import ReactApexChart from "react-apexcharts";

const AreaChart = ({
  labels = [],
  seriesData = [],
  colourTheme = ["#25CD25"],
  title = "",
}) => {
  const options = {
    chart: {
      type: "area",
      toolbar: { show: false },
      zoom: { enabled: false },
    },

    colors: colourTheme,

    dataLabels: { enabled: false },
    stroke: {
      curve: "straight",
      width: 2,
      dashArray: 6,
    },
    xaxis: { categories: labels },
    yaxis: {
      labels: {
        formatter: (val) => (val >= 1000 ? `${val / 1000}k` : val),
      },
    },

    fill: {
      type: "gradient",
      colors: colourTheme,
      gradient: {
        type: "vertical",
        shadeIntensity: 0,
        inverseColors: false,
        opacityFrom: 0.4,
        opacityTo: 0,
        stops: [0, 99.59],
      },
    },

    tooltip: { enabled: true },
    grid: {
      show: true,
      borderColor: "#E5E7EB",
      strokeDashArray: 0,
      xaxis: { lines: { show: true } },
      yaxis: { lines: { show: true } },
    },
  };

  const series = [
    {
      name: "API Volume",
      data: seriesData,
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      {title && (
        <div className="chart-title-container">
          <h3
            style={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 600,
              fontSize: "20px",
              margin: 0,
              color: "black",
            }}
          >
            {title}
          </h3>
        </div>
      )}

      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height={160}
      />
    </div>
  );
};

export default AreaChart;
